// src/components/SearchUserAutocomplete.jsx
import React, { useMemo, useState } from "react";
import { Autocomplete, TextField } from "@mui/material";
import { debounce } from "@mui/material/utils";
import api from "../services/api";

export default function SearchUserAutocomplete({ value, onChange, sx }) {
  const [options, setOptions] = useState([]);
  const [input, setInput] = useState("");
  const [loading, setLoading] = useState(false);

  const doSearch = useMemo(
    () =>
      debounce(async (q) => {
        if (!q) { setOptions([]); return; }
        try {
          setLoading(true);
          const { data } = await api.get("/usuarios-busca", { params: { q } });
          setOptions(data || []);
        } finally {
          setLoading(false);
        }
      }, 300),
    []
  );

  return (
    <Autocomplete
      options={options}
      loading={loading}
      size="small"
      disablePortal
      filterOptions={(x) => x}
      clearOnBlur={false}
      value={value}
      inputValue={input}
      onInputChange={(_e, v) => { setInput(v); doSearch(v); }}
      onChange={(_e, val) => onChange?.(val)}
      getOptionLabel={(o) => (o ? `${o.nome} — ${o.chave}` : "")}
      isOptionEqualToValue={(opt, val) => opt?.chave === val?.chave}
      renderInput={(params) => (
        <TextField {...params} label="Buscar revendedor/licença" sx={{ minWidth: 280 }} />
      )}
      ListboxProps={{ style: { maxHeight: 260 } }}
      sx={sx}
    />
  );
}
